<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado' || rol == 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else  grid-list-xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table 
                        ref="tableCocinas"
                        :tableName="'Cocinas'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        :perPage="[10, 25, 50, 100]"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :showAdvancedFilters="true">
                            <template slot="actionButtonsLeft">
                                <div class="botonAgregar" style="padding-right: 12px;">
                                    <v-btn
                                      rounded
                                      color="#004BAF"
                                      class="btnAdd"
                                      right
                                      @click="abrirModal('add')">
                                        <v-icon dark class="mr-2">add</v-icon>Agregar
                                        <div class="mr-4"></div>
                                    </v-btn>
                                </div>
                            </template>
                            <template slot="filters">
                                <v-row>
                                    <v-col v-if="rol === 'root'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                        <v-autocomplete
                                            :items="clientes"
                                            item-text="nombre"
                                            item-value="id"
                                            label="Cliente"
                                            outlined
                                            v-model="cliente_id"></v-autocomplete>
                                    </v-col>
                                    <v-col v-if="rol==='root' || rol ==='admin'"  cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                        <v-autocomplete
                                            :items="empresas"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="empresa_id"
                                            label="Empresa"
                                            outlined></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0" v-if="rol==='root' || rol ==='admin' || rol =='admin-empresa'">
                                        <v-autocomplete
                                            :items="sucursales"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="sucursal_id"
                                            label="Sucursal"
                                            outlined></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Nombre cocina"
                                            v-model="nombre_cocina"></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <tbody slot="body" slot-scope="{data}">
                                <tr :key="item.id" v-for="item in data">
                                    <td>
                                        <div class="tblPrincipal">{{ item.nombre }}</div>
                                    </td>
                                    <td>
                                        <div class="tblPrincipal">{{ item.cliente.nombre }}</div>
                                    </td>
                                    <td>
                                        <div class="tblPrincipal">{{ item.empresa.nombre }}</div>
                                    </td>
                                    <td>
                                        <div class="tblPrincipal">{{ item.descripcion }}</div>
                                    </td>
                                    <td>
                                        <div class="tblOpciones">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on}">
                                                    <v-btn 
                                                        v-on="on"
                                                        slot="activator"
                                                        class="botonHover"
                                                        icon
                                                        fab
                                                        dark
                                                        small
                                                        @click="abrirModal('update',item)">
                                                        <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editar</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on}">
                                                    <v-btn 
                                                        v-on="on"
                                                        slot="activator"
                                                        class="botonHover"
                                                        icon
                                                        fab
                                                        dark
                                                        small
                                                        @click="eliminarCocina(item.id)">
                                                        <v-icon class="tamIconoBoton invertirColorBotones">delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-dialog v-model="modal" persistent max-width="700px" scrollable>
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <perfect-scrollbar style="background: #FFF;">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{invalid}">
                            <v-card-title class="card_titulo">
                                <div class="headerModal">
                                    <!-- <img :src="imagen" alt="imgModal">
                                    <h2 class="titleModal">{{ titulo_modal }}</h2> -->
                                    <h2 class="ml-4 mb-10">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular 
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"></v-progress-circular>
                                    </div>
                                </div>
                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-row>
                                        <v-col v-if="rol == 'root'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                                <v-autocomplete
                                                outlined
                                                label="Cliente"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                v-model="cliente_id"
                                                required
                                                :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Empresa" rules="required">
                                                <v-autocomplete
                                                outlined
                                                label="Empresa"
                                                :items="empresas"
                                                item-text="nombre"
                                                item-value="id"
                                                v-model="empresa_id"
                                                required
                                                :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            
                                            <MultipleAutocomplete
                                            outlined
                                            :items="sucursales"
                                            :valorDefecto="sucursales_seleccionadas"
                                            :rules="'required'"
                                            item_text="nombre"
                                            @dataMultiple="(data)=> sucursales_seleccionadas = data"
                                            label="Sucursales"
                                            ref="multSucursal"></MultipleAutocomplete>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Nombre" rules="required">
                                                <v-text-field
                                                    outlined
                                                    autofocus
                                                    label="Nombre"
                                                    v-model="cocina.nombre"
                                                    required
                                                    :error-messages="errors"
                                                    ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Direccion" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Dirección"
                                                    v-model="cocina.direccion"
                                                    required
                                                    :error-messages="errors"
                                                    ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Responsable" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Responsable"
                                                    v-model="cocina.responsable"
                                                    required
                                                    :error-messages="errors"
                                                    ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Telefono" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Teléfono"
                                                    v-model="cocina.numero"
                                                    v-mask="'(###) ###-####'"
                                                    required
                                                    :error-messages="errors"
                                                    ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-textarea
                                                outlined
                                                label="Descripción"
                                                v-model="cocina.descripcion"
                                                no-resize
                                                rows="2"
                                                ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <ValidationProvider v-slot="{errors}" name="Hora máxima" rules="required">
                                                <v-text-field
                                                outlined
                                                label="Hora máxima"
                                                v-model="cocina.hora_maxima"
                                                type="time"
                                                required
                                                :error-messages="errors"
                                                >
                                                <template v-slot:append-outer>
                                                    <v-tooltip top class="pb-7">
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                                        </template>
                                                        <span class="pb-7 textTooltip">Establecer para los empleados, un <br> horario máximo para realizar un <br> pedido. Ejemplo: 10:00 a.m.</span>
                                                    </v-tooltip>  
                                                </template>  
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <v-btn  class="btnCerrar elevation-0"  @click="cerrar()" :disabled="loading_guardar">Cancelar</v-btn>
                                <v-btn class="btnGuardar elevation-0" @click="guardar()" :loading="loading_guardar">Guardar</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Datatable from "@/components/datatable/Datatable.vue"
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import MultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2'
import PerfectScrollbar from "perfect-scrollbar"
import clientesApi from '@/api/clientes'
import empresasApi from '@/api/empresas'
import cocinasApi from "@/api/cocinas"
import sucursalesApi from '@/api/sucursales'
import Notify from '@/plugins/notify'

    export default {
        components:{
    "data-table": Datatable,
    ValidationProvider,
    ValidationObserver,
    MultipleAutocomplete
    },
        data(){
            return{
                url: "comida-cocina/find",
                columns:[
                    {
                        label:"Cocina",
                        name:"cocina",
                        filterable:false
                    },
                    {
                        label:"Cliente",
                        name:"cliente",
                        filterable:false
                    },
                    {
                        label:"Empresa",
                        name:"empresa",
                        filterable:false
                    },
                    {
                        label:"Descripción",
                        name:'descripcion',
                        filterable:false
                    },
                    {
                        label:"Opciones",
                        name:"opciones",
                        filterable:false,
                        align:'center'
                    }
                ],
                titulo_modal:"",
                imagen:"/static/modal/clienteCreate.svg",
                cocina:{
                    id:null,
                    nombre:'',
                    descripcion:'',
                    cliente_id:null,
                    empresa_id:null,
                    direccion:'',
                    responsable:'',
                    numero:'',
                    hora_maxima:null,
                    sucursales:[]
                },
                //filtros asignados a la tabla de cocinas
                filters: {
                activo      : true,
                paginate    : true,
                order_by    : 'nombre',
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                nombre      : '',
                },
                clientes:[],
                empresas:[],
                sucursales:[],
                cliente_id:null,
                empresa_id:null,
                sucursal_id:null,
                nombre_cocina:'',
                sucursales_seleccionadas:[],
                finaliza_carga:true,
                loading_guardar:false,
                accion:'',
                modal:false,
                datosLogin:'',
                rol:'',
                params:{activo:true,paginate:false, order:'asc'}
            }
        },
        watch:{
            cliente_id: function(newVal) {
                if(newVal != null){
                    this.getEmpresas(newVal)
                }
            },
            empresa_id:function(newVal){
                if(newVal != null){
                    this.getSucursales(newVal)
                    this.sucursales_seleccionadas = []
                }
            },
        },
        methods:{
                listar(){
                this.datosLogin = this.$session.get('usuario')
                this.rol = this.datosLogin.rol.name  
                if(this.rol == 'admin'){
                    this.filters.cliente_id = this.datosLogin.cliente_id
                    this.cliente_id = this.datosLogin.cliente_id
                }else if(this.rol == 'admin-empresa'){
                    this.filters.empresa_id = this.datosLogin.empresa_id
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                }else if(this.rol == 'admin-sucursal'){
                    this.filters.sucursal_id = this.datosLogin.sucursal_id;
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.sucursal_id = this.datosLogin.sucursal_id
                }else{
                    this.filters.sucursal_id = this.datosLogin.sucursal_id;
                    this.cliente_id = this.datosLogin.cliente_id
                    this.empresa_id = this.datosLogin.empresa_id
                    this.sucursal_id = this.datosLogin.sucursal_id
                }
             },
             async loadModalData(){

                await this.reset()

                if(this.rol == 'root'){
                this.getClientes()
               }else if(this.rol == 'admin'){
                this.getEmpresas(this.cliente_id)
               }else if(this.rol == 'admin-empresa'){
                this.getSucursales(this.empresa_id)
               }else{
                this.getSucursales(this.empresa_id)
               }
             },
             setFilters(){

                this.filters.cliente_id = this.cliente_id
                this.filters.empresa_id = this.empresa_id
                this.filters.sucursal_id = this.sucursal_id
                this.filters.nombre = this.nombre_cocina
                //console.log(this.filters);
                this.$refs.tableCocinas.getData()

             },
             async abrirModal(accion, item = null){
                this.errors.clear()
                this.reset()
                this.accion = accion
                this.modal=true

                await this.loadModalData()
                
                if (accion == 'add'){
                    this.titulo_modal = 'Registrar cocina'
                }else{
                    this.titulo_modal = 'Actualizar cocina'
                    this.cocina.id = item.id
                    this.cocina.nombre = item.nombre
                    this.cliente_id = item.cliente_id
                    this.empresa_id = item.empresa_id
                    this.cocina.descripcion = item.descripcion
                    this.cocina.responsable = item.responsable
                    this.cocina.direccion = item.direccion
                    this.cocina.numero = item.numero
                    this.cocina.hora_maxima = this.formatHora(item.hora_maxima)
                    //console.log(this.cocina.hora_maxima);
                    this.sucursales_seleccionadas = await item.sucursales.map( item => {
                    return item.sucursal_id;
                });
                }
            },
            formatHora(time){
                //dar el formato de horas y minutos
                let timeArray = time.split(":");
                if (timeArray.length >= 2) {
                let hours = timeArray[0];
                let minutes = timeArray[1];
                let horaCorrecta = `${hours}:${minutes}` 
                //console.log(horaCorrecta);
                return horaCorrecta
                } else {
                    console.log("Invalid time string format");
                }
            },
            getClientes(){
                clientesApi.getClientes(this.params).then(resp =>{
                    //console.log(resp.data);
                    this.clientes = resp.data
                }).catch(err =>{
                    console.log('ocurrio un error al cargar los clientes',err);
                })
            },
            getEmpresas(id){
                let params = {...this.params, cliente_id:id}
                //console.log(params);
                empresasApi.getEmpresas(params).then(resp=>{
                    this.empresas = resp.data
                    //console.log(resp.data);
                }).catch(err =>{
                    console.log('Ocurrio un error al cargar las empresas', err);
                })
            },

            getSucursales(id){
                let params = {...this.params,empresa_id:id}
                sucursalesApi.getSucursales(params).then(resp =>{
                    this.sucursales = resp.data
                }).catch(err =>{
                    console.log('Ocurrio un error', err);
                })

            },
            guardar(){
                this.cocina.cliente_id = this.cliente_id
                this.cocina.empresa_id = this.empresa_id
                this.cocina.sucursales = this.sucursales_seleccionadas

                if(this.rol == 'admin-sucursal'){
                    this.cocina.sucursales = [this.sucursal_id]
                }

                this.$refs.form.validate().then(result =>{
                    if(result){
                        this.loading_guardar = true
                        if(this.accion === 'add'){
                            cocinasApi.addCocina(this.cocina).then(resp =>{
                                Notify.Success("Operación exitosa","La cocina se guardó satisfactoriamente")
                                this.$refs.tableCocinas.getData()
                                this.cerrar()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                        }
                        else if(this.accion === 'update'){
                            cocinasApi.updateCocina(this.cocina).then(resp =>{
                                Notify.Success("Operación exitosa","La cocina se actualizó satisfactoriamente")
                                this.$refs.tableCocinas.getData()
                                this.cerrar()
                            }).catch(err =>{
                                this.loading_guardar = false
                                if(typeof err.response.data.error === 'string'){
                                Notify.ErrorToast(err.response.data.error)
                                }else{
                                    let error = Object.values(err.response.data.error)
                                    let leyenda = ``

                                    for (var i = 0; i < error.length; i++){
                                        leyenda += `*` + error[i] + `\n`
                                    }

                                    Notify.ErrorToast(leyenda)
                                }
                            })
                        }
                    }
                })
            },
            eliminarCocina(id){
                console.log(id);
                Notify. Alert(
                    "ADVERTENCIA",
                    "¿Estás seguro que deseas eliminar la cocina actual?",
                    "Eliminar",
                    ()=>{
                        cocinasApi.deleteCocina(id).then(resp =>{
                            Notify.Success("Operación exitosa","La cocina se eliminó satisfactoriamente")
                            this.$refs.tableCocinas.getData()
                        }).catch(err =>{
                            //console.log(err);
                            if(typeof err.response.data.error === 'string'){
                                Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }
                        })
                    })
            },
            cerrar(){
                this.modal = false
                this.reset()
            },
            async reset(){
                this.cocina ={
                    nombre:'',
                    descripcion:'',
                    cliente_id:null,
                    empresa_id:null,
                    direccion:'',
                    responsable:'',
                    numero:''
                }
                
                this.loading_guardar = false
                this.sucursales_seleccionadas = []
                this.nombre_cocina = ''

                if(this.rol != 'admin-sucursal'){
                    this.sucursal_id = null
                }

                if(this.rol == 'root'){
                    this.cliente_id = null
                    this.empresa_id = null
                    this.empresas = []
                }else if(this.rol == 'admin'){
                    this.empresa_id = null
                }

                this.$nextTick(()=>{
                    if(this.$refs.form){
                        this.$refs.form.reset()
                    }
                })
            },
            redireccionar(){
                this.$router.push('/dashboard');
            },
        },
        created(){
            this.listar()
        }
    }
</script>

<style scoped>
h2{
    font-family: 'Montserrat';
    font-size: 18px;
    font-weight: 600;
    line-height: 21.94px;
}
</style>